import React from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Switch,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useSource } from './use-source';

type Props = {
  readonly isSelectedConsumptionInChart: boolean;
  readonly onToggleConsumption: () => void;
};

export function ConsumptionSelect({ isSelectedConsumptionInChart, onToggleConsumption }: Props) {
  const source = useSource();
  const { t } = useTranslation();

  return (
    <Accordion defaultIndex={[0]} allowMultiple id="consumption-select" data-testid="consumption-select">
      <AccordionItem>
        <AccordionButton>
          <Box as="span" flex="1" textAlign="left">
            {t('Activity.power consumption')}
          </Box>
          <AccordionIcon />
        </AccordionButton>

        <AccordionPanel>
          <Flex mb={4} align="center" justify="space-between">
            <Box>{t('Activity.total consumption').toUpperCase()}</Box>
            <Switch
              data-testid="consumption-toggle-switch"
              onChange={onToggleConsumption}
              isChecked={isSelectedConsumptionInChart}
              variant="consumptionYellow"
              isDisabled={!!source}
              size="lg"
            />
          </Flex>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
